module.exports = __webpack_public_path__ + "static/media/trustWallet.edcc1ab5.png";